import { SpecialInfoTypes } from '@booking/constants/special-info-types';

import { AssetTermBase } from './asset-terms.base';
import { CASHBACK_TRAVEL } from '../country-assets/PE/cashback';
import { CHUBB_TERMS } from '../country-assets/PE/chubb-pe';
import { RAPPI_TRAVEL_TERMS } from '../country-assets/PE/rappi-travel-pe';

export const AssetTerm = {
  ...AssetTermBase,
  CASHBACK_TRAVEL: CASHBACK_TRAVEL,
  CHUBB_TERMS: CHUBB_TERMS,
  DAVIVIENDA: null,
  RAPPI_TRAVEL: RAPPI_TRAVEL_TERMS,
  SUMMARY_TERMS_AND_POLICIES: {
    INDIVIDUAL_TERMS: false,
    CAMPAIGNS_TERMS_IN_FOOTER: true,
    INITIAL_TEXT: 'Leí y acepto',
    FINAL_TEXT: 'de RAPPI S.A.C',
    TERMS_AND_CONDITIONS: {
      INITIAL_TEXT: 'los',
      ALTERNATIVE_TEXT: 'y los',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['terms'] } }],
        TEXT: 'Términos y Condiciones de Nuevo Mundo',
        STATE: {}
      },
    },
    TREATMENT_PERSONAL_POLICIES: {
      DISABLED: true,
      INITIAL_TEXT: 'el',
      ALTERNATIVE_TEXT: '',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['treatment-personal-data'] } }],
        TEXT: 'Tratamiento de datos personales',
        STATE: {}
      }
    },
    PRIVACY_POLICIES: {
      INITIAL_TEXT: 'y la',
      ALTERNATIVE_TEXT: 'la',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['private-policy'] } }],
        TEXT: 'Política de Privacidad',
        STATE: {}
      }
    },
    CIVITATIS_POLICIES: {
      INITIAL_TEXT: 'los',
      ALTERNATIVE_TEXT: 'de Civitatis',
      HREF: {
        COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
        TEXT: 'Términos y Condiciones',
        STATE: {
          infoType: SpecialInfoTypes.CIVITATIS
        }
      }
    },
    CAMPAIGNS_TERMS: [
      {
        DISABLED: true,
        INITIAL_TEXT: 'los',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Términos y Condiciones de CHUBB Seguros',
          STATE: { infoType: SpecialInfoTypes.CHUBB }
        },
      },
      {
        DISABLED: false,
        INITIAL_TEXT: 'los',
        ALTERNATIVE_TEXT: '',
        HREF: {
          COMMANDS: [{ outlets: { 'terms': ['special-travel-data'] } }],
          TEXT: 'Términos y Condiciones de Rappi Travel',
          STATE: { infoType: SpecialInfoTypes.RAPPI_TRAVEL }
        },
      },
    ],
  }
};
